import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { ModalHelper } from '../../components/modal/modal.helper';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
var KindsModalComponent = (function () {
    function KindsModalComponent(_data, _blogic, _modal) {
        this._data = _data;
        this._blogic = _blogic;
        this._modal = _modal;
        this.id = 'atypesModal';
        this.destroy$ = new Subject();
    }
    KindsModalComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    /* Change the pre evaluation kind */
    KindsModalComponent.prototype.changeKind = function (id, name) {
        var _this = this;
        var params = {
            desk_id: this._data.session["desk"],
            turn_id: (this._data.turn != null) ? this._data.turn["id"] : this._data.selectedTurn["id"],
            prekind_id: id,
            deskuser: this._data.session["username"]
        };
        this._blogic.changeTurnKind(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._modal.hide(_this.id);
            if (_this._data.turn != null) {
                _this._data.turn["prekind_id"] = id;
                _this._data.turn["prekindname"] = name;
                _this._data.turnChanged();
            }
        });
    };
    KindsModalComponent.prototype.openKindModal = function (id) {
        this._modal.show(id);
    };
    return KindsModalComponent;
}());
export { KindsModalComponent };
